<button appButton name="close" location="website-mobile-menu" [iconButton]="true" color="simple" (click)="close()" class="close-button">
  <app-svg src="/assets/icons/cross.svg"></app-svg>
  <div class="button-hitbox-extender"></div>
</button>
<img src="/assets/picflow-icon.svg" alt="" width="48" height="48" class="logo-icon">
<div class="menu-buttons">


  <ng-container *ngFor="let item of menuStructure">

    <ng-container *ngIf="item.dropdown">
      <div appButton name="{{item.text | lowercase}}" location="website-mobile-menu" color="simple" weight="bold" spacing="full" size="4"
        (click)="dropdownStates[item.text] = !dropdownStates[item.text]">
        <span>{{item.text}}</span>
        <app-svg src="/assets/icons/16/arrow-down.svg" size="-1"></app-svg>
      </div>

      <div *ngIf="dropdownStates[item.text]" [@featuresMenu] class="features-menu">
        <ng-container *ngFor="let subItem of item.dropdown.items">
          <a [routerLink]="subItem.link" (click)="close()" appButton name="{{subItem.text | lowercase}}" location="website-mobile-menu"
            height="0-5" color="simple-gray" spacing="full" *ngIf="subItem.link">{{subItem.text}}</a>
          <a [href]="subItem.externalLink" target="_blank" (click)="close()" appButton
            name="{{subItem.text | lowercase}}" height="0-5" color="simple-gray" spacing="full"
            *ngIf="subItem.externalLink">{{subItem.text}}</a>
        </ng-container>
      </div>
    </ng-container>

    <a [routerLink]="item.link" (click)="close()" appButton name="{{item.text | lowercase}}" location="website-mobile-menu" color="simple"
      weight="bold" spacing="full" size="4" *ngIf="!item.dropdown">{{item.text}}</a>

  </ng-container>

  <div class="buttons">
    <a appButton name="login" location="website-mobile-menu" routerLink="/auth/login" spacing="full" (click)="close()" weight="bold">
      Log in
    </a>
    <a appButton name="sign-up" location="website-mobile-menu" routerLink="/auth/signup" spacing="full" (click)="close()"
      color="primary">Try for Free</a>
  </div>
